import classes from './Message.module.css';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { getFirestore, doc, deleteDoc } from 'firebase/firestore';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from '../firebase';

import React from 'react'

function Message({message, timestamp, user, userimage, id, channelId}) {
    const [currentUser] = useAuthState(auth);
    const isOwnMessage = currentUser?.displayName === user;

    const deleteMessage = async () => {
        if (!channelId || !id) return;
        await deleteDoc(doc(getFirestore(), 'rooms', channelId, 'messages', id));
    };

    return (
        <div className={classes['message-container']}>
            <img src={userimage} alt=""/>
            <div className={classes['message-info']}>
                <h4>{user} {''}
                    <span>
                        {new Date(timestamp?.toDate()).toUTCString()}
                    </span>
                </h4>
                <p>
                    {message}
                </p>
            </div>
            {isOwnMessage && (
                <DeleteOutlineIcon
                    className={classes['delete-icon']}
                    onClick={deleteMessage}
                    titleAccess="Delete message"
                />
            )}
        </div>
    )
}

export default Message
